var $c73bcadfc547eb5a$exports = {};
// Mendapatkan elemen DOM
const $c73bcadfc547eb5a$var$usernameDisplay = document.getElementById('username-display');
const $c73bcadfc547eb5a$var$logoutBtn = document.getElementById('logout-btn');
const $c73bcadfc547eb5a$var$userProfileImage = document.getElementById('profile-picture');
const $c73bcadfc547eb5a$var$profilePictureInput = document.getElementById('profile-picture-input');
const $c73bcadfc547eb5a$var$gamesContainer = document.querySelector('.games-container');
const $c73bcadfc547eb5a$var$loadingIndicator = document.getElementById('loading-indicator'); // Indikator loading
// Fungsi untuk memuat data game secara dinamis dari API atau server
const $c73bcadfc547eb5a$var$loadGames = async ()=>{
    try {
        $c73bcadfc547eb5a$var$loadingIndicator.style.display = 'block'; // Tampilkan indikator loading
        // Ambil data game dari API (misalnya Netlify Functions atau database)
        const response = await fetch('/api/getGames');
        const gamesData = await response.json();
        // Memasukkan data game ke dalam kontainer
        $c73bcadfc547eb5a$var$gamesContainer.innerHTML = ''; // Bersihkan kontainer game lama
        gamesData.forEach((game)=>{
            const gameItem = document.createElement('div');
            gameItem.classList.add('game-item');
            gameItem.innerHTML = `
        <a href="${game.link}" class="game-link">
          <h3>${game.title}</h3>
          <img src="${game.image}" alt="${game.description}" class="game-thumbnail">
          <p>${game.description}</p>
          <p>${game.status}</p>
        </a>
      `;
            $c73bcadfc547eb5a$var$gamesContainer.appendChild(gameItem);
        });
        $c73bcadfc547eb5a$var$loadingIndicator.style.display = 'none'; // Sembunyikan indikator loading
    } catch (error) {
        console.error('Error loading games:', error);
        alert('Terjadi kesalahan saat memuat game, coba lagi nanti.');
        $c73bcadfc547eb5a$var$loadingIndicator.style.display = 'none';
    }
};
// Cek jika pengguna sudah login
const $c73bcadfc547eb5a$var$checkUserStatus = ()=>{
    const user = JSON.parse(localStorage.getItem('user')); // Ambil data pengguna dari localStorage
    if (user) {
        $c73bcadfc547eb5a$var$usernameDisplay.innerText = user.username; // Menampilkan nama pengguna
        if (user.profilePicture) $c73bcadfc547eb5a$var$userProfileImage.src = user.profilePicture; // Menampilkan gambar profil
        $c73bcadfc547eb5a$var$logoutBtn.style.display = 'inline'; // Tampilkan tombol logout
    } else // Jika tidak ada pengguna yang terautentikasi, arahkan ke halaman login
    window.location.href = '/html/index.html'; // Pastikan path yang benar
};
// Fungsi logout
$c73bcadfc547eb5a$var$logoutBtn?.addEventListener('click', ()=>{
    localStorage.removeItem('user'); // Hapus data pengguna dari localStorage
    window.location.href = '/html/index.html'; // Arahkan ke halaman login setelah logout
});
// Fungsi untuk memperbarui gambar profil
const $c73bcadfc547eb5a$var$handleProfilePictureChange = async (event)=>{
    const user = JSON.parse(localStorage.getItem('user'));
    const file = event.target.files[0]; // Ambil file yang diupload
    if (user && file) try {
        $c73bcadfc547eb5a$var$loadingIndicator.style.display = 'block'; // Tampilkan indikator loading
        // Simulasi upload gambar ke server atau penyimpanan cloud
        // Upload gambar ke server dan dapatkan URL gambar baru
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetch('/api/uploadProfilePicture', {
            method: 'POST',
            body: formData
        });
        if (!response.ok) throw new Error('Gagal mengunggah gambar profil');
        const updatedUser = {
            ...user,
            profilePicture: await response.text()
        }; // Mendapatkan URL gambar dari server
        localStorage.setItem('user', JSON.stringify(updatedUser)); // Simpan perubahan
        $c73bcadfc547eb5a$var$userProfileImage.src = updatedUser.profilePicture; // Update gambar profil di halaman
        $c73bcadfc547eb5a$var$loadingIndicator.style.display = 'none'; // Sembunyikan indikator loading
    } catch (error) {
        console.error("Error uploading profile picture:", error.message);
        alert('Gagal mengunggah gambar profil. Silakan coba lagi.');
        $c73bcadfc547eb5a$var$loadingIndicator.style.display = 'none';
    }
    else alert('File tidak valid atau pengguna tidak ditemukan.');
};
// Menangani perubahan gambar profil (misalnya, input file)
$c73bcadfc547eb5a$var$profilePictureInput?.addEventListener('change', $c73bcadfc547eb5a$var$handleProfilePictureChange);
// Panggil fungsi untuk memeriksa status pengguna saat halaman dimuat
$c73bcadfc547eb5a$var$checkUserStatus();
// Muat game saat halaman dimuat
$c73bcadfc547eb5a$var$loadGames();


//# sourceMappingURL=index.fb8af489.js.map
